<template>
  <section v-if="$wp.secondaryDataLoaded" class="layout-section -bg-shade">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">Nos événements</h2>
    </div>

    <div class="card-article">
      <RouterLink
        v-for="(publication, index) in publicationsPage"
        :key="getEntryKey(publication)"
        v-scroll:reveal="{ delay: (index % 3) * 75, offset: 0 }"
        :to="{ name: 'event-single', params: { eventSlug: publication.slug } }"
        class="card-article__item"
      >
        <section class="card-article__type">
          <template v-if="getIcon(publication)">
            <span class="tag -float -small">
              <SvgIcon :id="getIcon(publication)" />
              {{ getTag(publication) }}
            </span>
          </template>

          <div v-if="getIsUpcoming(publication)" class="tag -small -float -accent">À venir</div>
        </section>

        <div class="card-article__figure" :style="{ backgroundImage: `url('/images/brand/placeholder.png')` }">
          <figure class="card-article__image" :style="{ backgroundImage: `url('${getImage(publication)}')` }" />
        </div>

        <section class="card-article__content">
          <section class="card-article__uptitle">
            <div class="card-article__data -accent">
              <SvgIcon id="content-date" />
              <p>{{ getFormattedDate(publication) || 'Aucune date' }}</p>
            </div>
          </section>

          <h4 class="card-article__title">
            {{ publication.shortTitle || publication.title }}
          </h4>
        </section>
      </RouterLink>
    </div>

    <div v-scroll:reveal class="layout-section__controls">
      <RouterLink :to="{ name: 'event-index' }" class="button layout-section__cta">
        Voir tous les événements
        <SvgIcon id="action-arrow" />
      </RouterLink>
    </div>
  </section>
</template>

<script>
import moment from 'moment'
import { safeArray } from '@/helpers/search-helpers'
import { eventTypeTagMap, eventTypeIconMap } from '@/helpers/type-maps'

export default {
  name: 'EventsIndex',
  computed: {
    publicationsPage() {
      const events = this.$wp.eventPublications || []
      return events.slice(0, 3)
    }
  },
  methods: {
    getIsUpcoming(publication) {
      return publication && publication.date ? moment(publication.date).isAfter(moment()) : false
    },
    getTag(publication) {
      return eventTypeTagMap[publication.eventType] || null
    },
    getIcon(publication) {
      return eventTypeIconMap[publication.eventType] || null
    },
    getImage(publication) {
      if (publication.featuredImage) return publication.featuredImage
      if (!publication.images || !publication.images.length) return '/images/brand/placeholder.png'

      const [image1, image2 = null] = publication.images
      return image1 || image2
    },
    getFormattedDate(publication) {
      return publication && publication.date ? moment(publication.date).format('D MMMM YYYY') : null
    },
    getEntryKey(entry) {
      const key = entry.id || `${entry.slug}-${entry.type}`
      return `${key}-${JSON.stringify(this.$route.query)}`
    },
    filterKeywordMatches(entries) {
      if (!this.currentKeywords.length) return entries

      return entries.filter(entry => {
        if (!entry || !entry.keywords) return false

        return safeArray(entry.keywords)
          .map(id => this.$wp.keywordsById[id] && this.$wp.keywordsById[id].slug)
          .filter(Boolean)
          .some(slug => this.currentKeywords.includes(slug))
      })
    }
  }
}
</script>
